import PropTypes from 'prop-types';
import { useState } from 'react';
import Input from './Input';

const PasswordVisibilityToggle = ({ getLabel, showPassword, togglePassword }) => {
	const title = getLabel(showPassword ? 'password_toggle_hide' : 'password_toggle_show');
	return (
		<button data-testid="showPassword" className="password__visibility-toggle" onClick={togglePassword} aria-label={title} title={title}>
			<span aria-hidden="true">{showPassword ? 'visibility_off' : 'visibility'}</span>
		</button>
	);
};

const PasswordDirective = ({ checked = false, label }) => {
	return <div className={`password__directive${checked ? ' password__directive--checked' : ''}`}>{label}</div>;
};

export default function Password({ fieldIsValid, getFieldErrorMessages, getLabel, label, name, onChange, required, validation, value, visibleErrors }) {
	const [showPassword, setShowPassword] = useState(false);
	const togglePassword = () => setShowPassword(!showPassword);

	return (
		<fieldset className="password-field">
			<Input
				fieldIsValid={fieldIsValid}
				getFieldErrorMessages={getFieldErrorMessages}
				label={label}
				name={name}
				onChange={onChange}
				required={required}
				type={showPassword ? 'text' : 'password'}
				visibleErrors={visibleErrors}
				value={value}
			>
				<PasswordVisibilityToggle showPassword={showPassword} togglePassword={togglePassword} getLabel={getLabel} />
			</Input>
			<div className="password__directives">
				{validation.map(({ callback, directive }, index) => {
					return <PasswordDirective key={index} checked={callback({ value })} label={directive} />;
				})}
			</div>
		</fieldset>
	);
}

Password.propTypes = {
	fieldIsValid: PropTypes.func.isRequired,
	getFieldErrorMessages: PropTypes.func.isRequired,
	getLabel: PropTypes.func.isRequired,
	label: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	required: PropTypes.bool,
	validation: PropTypes.array.isRequired,
	value: PropTypes.string.isRequired,
	visibleErrors: PropTypes.bool.isRequired,
};

PasswordDirective.propTypes = {
	checked: PropTypes.bool,
	label: PropTypes.string.isRequired,
};

PasswordVisibilityToggle.propTypes = {
	getLabel: PropTypes.func.isRequired,
	showPassword: PropTypes.bool,
	togglePassword: PropTypes.func,
};
